import { Link } from "react-router-dom";

export default function NotFound() {
    return (

        <>

            <div className="container h-screen dark:bg-violet bg-primary opacity-75 dark:bg-opacity-75">

                    <h2 data-aos="fade-left" className='font-customFont2 dark:text-shadow-xxl text-center text-darkest dark:text-primary text-5xl sm:text-4xl md:text-5xl lg:text-5xl xl:text-6xl 2xl:text-6xl font-bold leading-[1.2] mb-8 pt-44'>Valitettavasti sivua ei löydy!</h2><br />
                    
                    <p data-aos="fade-right" className="font-customFont1 dark:text-shadow-xxl text-center text-darkest dark:text-primary text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-normal">
            
                        Hups! Näyttää siltä, että etsit sivua, jota ei ole olemassa. Älä huoli, ei se haittaa!<br />
                        Klikkaa itesesi <Link className="font-customFont1 dark:text-shadow-lg text-center text-darkest dark:text-primary text-lg sm:text-lg md:text-lg lg:text-lg xl:text-xl 1xl:text-1xl font-bold underline" to="/">tästä</Link> etusivulle.
                    </p>

            </div>

        </>
    );
}

